export const iconFontAwesomeDevicesHardwareDownload = (
	<i className="fa-solid fa-download"></i>
);
